import type { Notification } from '../../types';
import { createOrderNotification, createGenericNotification } from '../../utils/browserNotification';

export function buildBrowserNotification(newNotification: Notification) {
  const notifType = String(newNotification.type || 'new_order');
  const meta = (newNotification as any).metadata || {};
  const cmx: string | null = meta.cmx
    || (meta.order_no !== undefined && meta.order_no !== null && String(meta.order_no) !== ''
      ? `#CMX-${String(Number(meta.order_no)).padStart(7, '0')}` : null);

  if (notifType === 'ORDER_NEW' || notifType === 'new_order' || notifType === 'DIGITAL_ORDER_NEW') {
    const orderNumber = cmx || newNotification.message?.match(/Order #(\S+)/)?.[1] || 'XXXXX';
    const customerMatch = newNotification.message?.match(/dari (.+?) -/);
    const totalMatch = newNotification.message?.match(/Rp ([\d,.]+)/);
    const customerName = customerMatch?.[1] || 'Customer';
    const total = totalMatch?.[1] ? parseFloat(totalMatch[1].replace(/[,.]/g, '')) : 0;

    return createOrderNotification(orderNumber, customerName, total);
  }

  if (notifType === 'ORDER_STATUS' || notifType === 'order_status' || notifType === 'SYSTEM_ALERT') {
    const msg = cmx
      ? newNotification.message.replace(/#[0-9a-fA-F]{8}\b/, cmx)
      : newNotification.message;
    return createGenericNotification(
      newNotification.title || 'Status Pesanan Berubah',
      msg || '',
      notifType
    );
  }

  return createGenericNotification(
    newNotification.title || 'Notifikasi Baru',
    newNotification.message || '',
    notifType
  );
}
